/**
 * Single source of truth for rendering credit balances.
 *
 * Rules:
 * - Round to 2 decimal places (no more, no less precision).
 * - If the rounded value is a whole number, drop decimals entirely
 *   ("1,030" rather than "1,030.00").
 * - Fractional values always render with exactly 2 decimals
 *   ("0.50", not "0.5"; "1,030.09", not "1,030.088").
 * - Non-finite input (NaN, Infinity) renders as "0" so the UI never
 *   shows a broken balance.
 *
 * Use this for every customer-facing credit balance — header pill,
 * billing card, profile team card, onboarding copy, CSV exports.
 */
export function formatCredits(n: number): string {
  if (!Number.isFinite(n)) return '0';
  const rounded = Math.round(n * 100) / 100;
  const isWhole = Number.isInteger(rounded);
  return rounded.toLocaleString('en-US', {
    minimumFractionDigits: isWhole ? 0 : 2,
    maximumFractionDigits: 2,
  });
}
